/**
 * What a Vorgang drawn by hand is called when nobody names it — what every
 * one of them was called before it could be named (Task 14, UX-Gutachten
 * 23.10.2026: four „Umriss von Hand · kein Kunde" in the list, told apart
 * only by their number).
 */
export const MANUAL_CASE_TITLE = "Umriss von Hand";

/**
 * The server's limit on a Vorgang's name (`CaseCreateIn.title`,
 * `max_length=200`) — pinned against `openapi.json` in the test beside this.
 */
export const CASE_TITLE_MAX = 200;

/** What was typed, cut at the server's limit — counted in characters, as the server counts. */
export function capCaseTitle(typed: string): string {
  const characters = Array.from(typed);
  return characters.length <= CASE_TITLE_MAX ? typed : characters.slice(0, CASE_TITLE_MAX).join("");
}

/**
 * The name „Übernehmen" sends: what was typed, without the blanks around it
 * and with any run of blanks inside it made one (a pasted address), or
 * {@link MANUAL_CASE_TITLE} for a field left empty. The server takes any
 * non-empty string — „ " would have become a Vorgang named by a space.
 */
export function caseTitleFrom(typed: string): string {
  const name = capCaseTitle(typed.replace(/\s+/g, " ").trim());
  return name === "" ? MANUAL_CASE_TITLE : name;
}
